import React from 'react';
import { formatRunningHubCosExpiryLabel } from '../utils/runningHubRetention';

interface RunningHubCosExpiryBadgeProps {
  timestamp: number;
  lang: 'zh' | 'en';
  className?: string;
}

/**
 * RunningHub / 侧栏功能历史：COS 约 7 天生命周期倒计时（与 runningHubRetention 一致）
 */
export const RunningHubCosExpiryBadge: React.FC<RunningHubCosExpiryBadgeProps> = ({
  timestamp,
  lang,
  className = '',
}) => (
  <span
    className={`inline-flex items-center rounded-md border border-white/20 bg-black px-2 py-0.5 text-[9px] font-medium leading-tight text-pink-200 ${className}`}
    style={{ textShadow: '0 1px 2px rgba(0,0,0,0.85)' }}
  >
    {formatRunningHubCosExpiryLabel(timestamp, lang)}
  </span>
);
